import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Layout, Result, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

// 이전 디자인 (롤백용)
// import { Introduction, OrganList } from "../component/main";
// 디자인 시안 선택 메뉴 (시안 A 채택으로 숨김, 롤백용)
// import { Dropdown } from "antd";
// import type { MenuProps } from "antd";
// import { ExperimentOutlined, DownOutlined } from "@ant-design/icons";
// import { GALLERY_DRAFTS } from "../component/gallery";
import { GalleryCover } from "../component/gallery";
import { ACCESS_TOKEN } from "../lib/cookie";
import { getLoginUser } from "../api/user";

const authorizedRoles = [
  'ADMIN_MAIN', 
  'ADVISOR', 
  'REGULAR', 
  'STUDENT', 
  'SPEACIAL', 
  'GENERAL'
];

const Main = () => {
  const [loading, setLoading] = useState(true);
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  // 신규 디자인 시안 버튼 노출 여부 (시안 A 채택으로 숨김, 롤백용)
  // const [isAdmin, setIsAdmin] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem(ACCESS_TOKEN)) {
      navigate("/login");
    }
    getLoginUser().then((data) => {
      if (data?.role && authorizedRoles.includes(data.role)) {
        setIsUnauthorized(false);
      } else {
        setIsUnauthorized(true);
      }
      // setIsAdmin(data?.role === "ADMIN_MAIN");
      setLoading(false);
    }).catch((error) => {
      console.error("로그인 정보 조회 실패:", error);
      setIsUnauthorized(true);
      // setIsAdmin(false);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Layout.Content style={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <LoadingOutlined style={{ fontSize: 48, color: "#1677ff" }} spin />
      </Layout.Content>
    );
  }

  if (isUnauthorized) {
    return (
      <Layout.Content style={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Result
          status="403"
          title="접근 권한 없음"
          subTitle="해당 게시판에 접근 권한이 없습니다."
          extra={
            <Button type="primary" onClick={() => navigate("/")}>
              메인으로 돌아가기
            </Button>
          }
        />
      </Layout.Content>
    );
  }

  // 디자인 시안 A(썸네일 카드) 채택 — 시안 B·C 는 page/GalleryDraft*.tsx 에 코드로만 남겨둔다
  return <GalleryCover />;

  // ---- 이전 디자인 + 시안 선택 메뉴 (롤백용) ----
  // // 신규 디자인 시안 진입 메뉴 (검토용 — 시안 확정 후 이 버튼과 /gallery-draft/* 는 제거)
  // const draftMenu: MenuProps = {
  //   items: GALLERY_DRAFTS.map((draft) => ({
  //     key: draft.key,
  //     label: (
  //       <div style={{ padding: "4px 0", maxWidth: 280 }}>
  //         <div style={{ fontWeight: 600 }}>{draft.name}</div>
  //         <div style={{ fontSize: 12, color: "#8a94a3", whiteSpace: "normal", lineHeight: 1.4 }}>
  //           {draft.tagline}
  //         </div>
  //       </div>
  //     ),
  //     onClick: () => navigate(draft.path),
  //   })),
  // };
  //
  // return (
  //   <Layout.Content>
  //     <div style={{ margin: "2rem auto", maxWidth: "85%" }}>
  //       {isAdmin && (
  //         <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "-1rem" }}>
  //           <Dropdown menu={draftMenu} placement="bottomRight" trigger={["click"]}>
  //             <Button icon={<ExperimentOutlined />}>
  //               신규 디자인 시안 보기 <DownOutlined style={{ fontSize: 10 }} />
  //             </Button>
  //           </Dropdown>
  //         </div>
  //       )}
  //       <Introduction />
  //       <OrganList />
  //     </div>
  //   </Layout.Content>
  // );
};

export default Main;
